module.exports = {
  title: 'Verification Code with Reanimated and Skia 👀',
  author: 'Enzo Manuel Mangano',
  date: '2024-12-17',
  slug: 'verification-code-face',
  tags: ['skia', 'reanimated'],
};
